/**
 * ReadOnlyPopover — shown when user clicks a locked field while in edit mode.
 *
 * The Closed/Non-Op, Open 24hr, and 24hr-day drive-thru/dining-room cells are
 * server-controlled (DOP block extents). This popover explains they're read-only
 * and surfaces the Contact Support link (wires to SnapEngage chat).
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, HStack, Pressable } from 'native-base';
import { CloseIcon } from 'native-base';
import { Text } from '@pimm/base';
import { ContactSupportLink } from './contact-support-link';
import { Lock01Icon } from '@pimm/base';

type Props = {
  onClose: () => void;
};

export const ReadOnlyPopover = ({ onClose }: Props) => {
  const { t } = useTranslation();
  return (
    <Box position="absolute" top={0} left={0} right={0} bottom={0} zIndex={10}>
      <Pressable
        position="absolute" top={0} left={0} right={0} bottom={0}
        bg="rgba(0,0,0,0.2)" onPress={onClose}
      />
      <Box
        position="absolute" top={0} left={0} right={0} bottom={0}
        alignItems="center" justifyContent="center"
        // @ts-ignore
        pointerEvents="box-none"
      >
        <Box bg="white" rounded="xl" maxW="280px" w="90%" shadow={9} px={4} py={3}>
          <HStack alignItems="center" justifyContent="space-between" mb={2}>
            <HStack alignItems="center" space={2}>
              <Lock01Icon size={3} color="gray.400" />
              <Text size="sm" fontWeight={600} color="gray.800">{t('store_settings:read_only_setting')}</Text>
            </HStack>
            <Pressable onPress={onClose}>
              <CloseIcon size={3} color="gray.500" />
            </Pressable>
          </HStack>
          <Text size="sm" color="gray.500" mb={3} lineHeight={20}>
            {t('store_settings:read_only_support_note')}
          </Text>
          {/* <ContactSupportLink
            message={t('store_settings:contact_support')}
            pageModule="Store Hours"
            onPress={onClose}
          /> */}
        </Box>
      </Box>
    </Box>
  );
};
